<template>
  <div>
    <v-row>
      <v-col cols="12"><h1 class="font-weight-thin">Roles</h1></v-col>
    </v-row>
    <v-card>
      <v-data-table :headers="headerListFormatted" :hide-default-footer="true" :items="itemList" disable-pagination>
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.label }}</td>
            <td v-for="(perm, name) in item.permission" :key="name">{{ perm ? "x" : "-" }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-list>
        <template v-for="(permission, index) in permissionList">
          <v-list-item :key="index">
            <v-list-item-content :key="index">{{ index }} - {{ permission.label }}</v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import permissionApi from "@/api/permission";
import roleApi from "@/api/role";

export default {
  async created() {
    const permissionList = await permissionApi.list();
    const roleList = await roleApi.list();

    this.headerListFormatted = cloneDeep(permissionList);

    this.headerListFormatted.forEach((item, index) => {
      item.sortable = false;
      item.text = index;
    });

    this.headerListFormatted.unshift({
      sortable: false,
      text: "Role Name",
    });

    this.permissionList = permissionList;
    this.itemList = roleList;
  },
  data() {
    return {
      permissionList: [],
      headerListFormatted: [],
      itemList: [],
    };
  },
};
</script>
